/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Access_Permissions_LabelInputs */



/**
* | output |
* | --- |
* | "Access Permissions" |
*
* @param {Knp_Guide_Access_Permissions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_access_permissions_label = /** @type {((inputs?: Knp_Guide_Access_Permissions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Access_Permissions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations d’accès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugriffsberechtigungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizzazioni di accesso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Права доступа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos de acceso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("访问权限")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクセス権限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहुँच अनुमतियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões de acesso")
	return /** @type {LocalizedString} */ ("Access Permissions")
});